export default __webpack_public_path__ + "static/concies-commerce-676676b8240455965493326a4f5d2bb5.svg";